import { create } from 'zustand';

// Permet de stocker tous les topics demandés pour l'écoute d'URL via Mercure
export const useStoreMercureTopics = create((set, get) => ({
    topics: [],
    addTopics: (topic: string) => {
        const {topics} = get();

        if (!topics.includes(topic)) {
            set({topics: [...topics, topic]})
        }
    }
}));